import React from "react";
import { getLanguage } from "./SecurityService";
import i18n from "../modules/i18n/i18n.js";

// Email validation is language-independent (RFC-style ASCII syntax is identical
// across locales), so it lives here as a single source of truth rather than in
// per-language locale files. Used by all email-input validators.
export const EMAIL_PATTERN = /^[a-zA-Z0-9_.\-^'`?=]+@([a-zA-Z0-9-]+\.)+([a-zA-Z0-9]{2,63})$/;
/* export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}; */
 
 
export const formatDate = (input) => {
  if (!input) return "";
 
  // If already in YYYY-MM-DD format
  if (typeof input === "string") {
    return input.length >= 10 ? input.slice(0, 10) : "";
  }
 
  // If Date object
  if (input instanceof Date && !isNaN(input)) {
    const year = input.getFullYear();
    const month = String(input.getMonth() + 1).padStart(2, "0");
    const day = String(input.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
 
  // Fallback (moment/dayjs)
  try {
    const d = new Date(input);
    if (!isNaN(d)) {
      return d.toISOString().split("T")[0];
    }
  } catch {}
 
  return "";
};
 
// Format date from "DD/MM/YYYY" to "DD Month YYYY" eg. → "26 October 2024"
// export const formatDateToLong = (dateStr) => {
export const formatDateToLong = (dateStr, t) => {
  if (!dateStr) return "";
 
  const [dd, mm, yyyy] = dateStr.split("/").map(Number);
 
  const monthNames = [
    t("January"),
    t("February"),
    t("March"),
    t("April"),
    t("May"),
    t("June"),
    t("July"),
    t("August"),
    t("September"),
    t("October"),
    t("November"),
    t("December")
  ];
 
  const month = monthNames[mm - 1];
 
  return `${dd} ${month} ${yyyy}`;
};
 
/* export const formatDateToLong = (dateStr) => {
  if (!dateStr) return "";
 
  const [dd, mm, yyyy] = dateStr.split("/").map(Number);
  const date = new Date(yyyy, mm - 1, dd);
 
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
}; */
 
export const delay = async (ms) => await new Promise(resolve => setTimeout(resolve, ms));
export const Modaldelay = (ms) =>   new Promise(resolve => setTimeout(resolve, ms));
 
// ✅ Get Monday-based week key
export const getWeekKey = (date) => {
  if (!date) return null;
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  const monday = new Date(d.setDate(diff));
  return `${monday.getFullYear()}-${monday.getMonth()}-${monday.getDate()}`;
};
 
// ✅ Normalize date (YYYY-MM-DD)
export const getBookingDateStr = (date) => {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d)) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
 
// Convert date to EEE dd MMM format-Mon 12 Jan
/* export const formatDateToEEEddMMM  = (dateStr) => {
/* export const formatDateToEEEddMMM  = (dateStr) => {
  const date = new Date(dateStr);
 
  return date.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "short",
  });
}; */
export const formatDateToEEEddMMM = (dateStr) => {
  const date = new Date(dateStr);
 
  const weekday = date
    .toLocaleDateString("en-GB", { weekday: "short" })
    .toLowerCase();
 
  const day = date.toLocaleDateString("en-GB", { day: "2-digit" });
 
  const month = date
    .toLocaleDateString("en-GB", { month: "long" })
    .toLowerCase();
    //console.log("formatDateToEEEddMMM=>",weekday,day,month)
let monthKey=`month_3digit_of_${month}`
  return `${i18n.t(weekday)} ${day} ${i18n.t(monthKey)}`;
};
 
// Safe float conversion
export const toSafeFloat = (value, fallback = null) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
};
// eg.result-toSafeFloat("-1")= -1,toSafeFloat(-1) = -1, toSafeFloat("1.5") = 1.5, toSafeFloat("")  = null, toSafeFloat(null) = null, toSafeFloat(undefined) = null, toSafeFloat("abc", 0)  = 0
 
export const getCurrentDateTime = () => {
    const now = new Date();
 
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
 
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
//console.log("getCurrentDateTime=>",`${year}-${month}-${day} ${hours}:${minutes}:${seconds}`)
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const CreditRefundType = {
  DEFAULT: "DEFAULT",
  NO_REFUND: "NO_REFUND",
  HALF_REFUND: "HALF_REFUND",
  FULL_REFUND: "FULL_REFUND"
};

const parseDateTimeString = (dateTimeStr) => {
  if (typeof dateTimeStr !== "string") {
    throw new Error("Date-time value must be a string.");
  }

  const match = dateTimeStr.match(
    /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/
  );

  if (!match) {
    throw new Error(`Invalid date-time format: ${dateTimeStr}`);
  }

  const [, year, month, day, hour, minute, second] = match.map(Number);
  const parsedDate = new Date(year, month - 1, day, hour, minute, second);

  const isValidDate =
    parsedDate.getFullYear() === year &&
    parsedDate.getMonth() === month - 1 &&
    parsedDate.getDate() === day &&
    parsedDate.getHours() === hour &&
    parsedDate.getMinutes() === minute &&
    parsedDate.getSeconds() === second;

  if (!isValidDate) {
    throw new Error(`Invalid date-time value: ${dateTimeStr}`);
  }

  return parsedDate;
};

export const getCreditRefundType = (
  startDateTime,
  endDateTime,
  currentDateTime
) => {
  try {
   /*  console.log("getCreditRefundType-inputs:", {
      startDateTime,
      endDateTime,
      currentDateTime
    }); */

    const normalizeDateTime = (dateTimeStr) => {
      if (typeof dateTimeStr !== "string") {
        return dateTimeStr;
      }

      return dateTimeStr.includes("T")
        ? dateTimeStr.replace("T", " ")
        : dateTimeStr;
    };

    const normalizedStart = normalizeDateTime(startDateTime);
    const normalizedEnd = normalizeDateTime(endDateTime);
    const normalizedCurrent = normalizeDateTime(currentDateTime);

    /* console.log("getCreditRefundType-normalized:", {
      normalizedStart,
      normalizedEnd,
      normalizedCurrent
    }); */

    const start = parseDateTimeString(normalizedStart);
    const end = parseDateTimeString(normalizedEnd);
    const current = parseDateTimeString(normalizedCurrent);
    //console.log("getCreditRefundType-Parsed date-times:", { start, end, current });
    if (current < start) {
      return CreditRefundType.FULL_REFUND;
    }

    if (current > end) {
      return CreditRefundType.NO_REFUND;
    }

    return CreditRefundType.HALF_REFUND;
  } catch (error) {
    /* console.error(
      "getCreditRefundType: Failed to parse date-time string:",
      error?.message || error
    ); */
    return CreditRefundType.DEFAULT;
  }
};

export const getDisplayRefundCreditValue = ({
  refundStartDateTime,
  refundEndDateTime,
  zoneCurrentDateTime,
  fullRefundCredit,
  halfRefundCredit,
  noRefundCredit
} = {}) => {
  /* console.log("getDisplayRefundCreditValue-inputs:", {
    refundStartDateTime,
    refundEndDateTime,
    zoneCurrentDateTime,
    fullRefundCredit,
    halfRefundCredit,
    noRefundCredit
  }); */

  const refundType =
    refundStartDateTime && refundEndDateTime && zoneCurrentDateTime
      ? getCreditRefundType(
        refundStartDateTime,
        refundEndDateTime,
        zoneCurrentDateTime
      )
      : CreditRefundType.DEFAULT;

  if (!(refundStartDateTime && refundEndDateTime && zoneCurrentDateTime)) {
    //console.log("getDisplayRefundCreditValue-skipped getCreditRefundType due to missing input");
  }

  switch (refundType) {
    case CreditRefundType.FULL_REFUND:
      return fullRefundCredit || "0";
    case CreditRefundType.HALF_REFUND:
      return halfRefundCredit || "0";
    case CreditRefundType.NO_REFUND:
      return noRefundCredit || "0";
    default:
      return "0";
  }
};
export const formatDateYYYYMMDD = (input) => {
    if (!input) return "";
 
    const date = input instanceof Date ? input : new Date(input);
 
    if (isNaN(date)) return "";
 
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
 
// coming in 12-hour AM/PM format, this function will convert them to 24-hour format
export const convertTo24Hour = (time12h) => {
  if (!time12h) return "";
 
  const [time, modifier] = time12h.split(" ");
  let [hours, minutes] = time.split(":");
 
  hours = parseInt(hours, 10);
 
  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  }
 
  if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes}`;
};

export const isPastTimeInterval = (
  slotTime,
  zoneCurrentTime,
  bookingDate,
  zoneCurrentDate
) => {
  if (!slotTime || !zoneCurrentTime || !bookingDate || !zoneCurrentDate) {
    return false;
  }

  if (formatDate(bookingDate) !== formatDate(zoneCurrentDate)) {
    return false;
  }

  const [, slotEnd = ""] = String(slotTime)
    .split("-")
    .map((value) => value.trim());

  if (!slotEnd) {
    return false;
  }

  const parseMinutes = (timeValue) => {
    const [hours, minutes] = String(timeValue || "")
      .split(":")
      .map(Number);

    if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
      return null;
    }

    return (hours * 60) + minutes;
  };

  const slotEndMinutes = parseMinutes(slotEnd);
  const zoneCurrentMinutes = parseMinutes(zoneCurrentTime);

  if (slotEndMinutes === null || zoneCurrentMinutes === null) {
    return false;
  }

  return slotEndMinutes <= zoneCurrentMinutes;
};

const parseTimeToMinutes = (timeValue) => {
  const [hours, minutes] = String(timeValue || "")
    .split(":")
    .map(Number);

  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
    return null;
  }

  return (hours * 60) + minutes;
};

export const shouldBlockWeeklyCalendarTimedSlotClick = ({
  clickedDateTime,
  clickedSlotEndDateTime,
  isAllDay,
  zoneCurrentDate,
  zoneCurrentTime,
  spotMinStartTime,
  spotMaxEndTime
} = {}) => {
  if (isAllDay) {
    return false;
  }

  if (!clickedDateTime || !zoneCurrentDate || !zoneCurrentTime) {
    return false;
  }

  const clickedDate = formatDate(clickedDateTime);

  if (clickedDate !== formatDate(zoneCurrentDate)) {
    return false;
  }

  const clickedTimeMinutes = parseTimeToMinutes(
    clickedDateTime instanceof Date
      ? `${String(clickedDateTime.getHours()).padStart(2, "0")}:${String(
        clickedDateTime.getMinutes()
      ).padStart(2, "0")}`
      : ""
  );
  const clickedSlotEndMinutes = parseTimeToMinutes(
    clickedSlotEndDateTime instanceof Date
      ? `${String(clickedSlotEndDateTime.getHours()).padStart(2, "0")}:${String(
        clickedSlotEndDateTime.getMinutes()
      ).padStart(2, "0")}`
      : ""
  );
  const zoneCurrentMinutes = parseTimeToMinutes(zoneCurrentTime);
  const spotMinStartMinutes = parseTimeToMinutes(spotMinStartTime);
  const spotMaxEndMinutes = parseTimeToMinutes(spotMaxEndTime);

  if (clickedTimeMinutes === null || zoneCurrentMinutes === null) {
    return false;
  }

  if (
    spotMinStartMinutes !== null &&
    clickedTimeMinutes < spotMinStartMinutes
  ) {
    return true;
  }

  if (
    spotMaxEndMinutes !== null &&
    clickedTimeMinutes >= spotMaxEndMinutes
  ) {
    return true;
  }

  if (clickedSlotEndMinutes !== null) {
    return zoneCurrentMinutes >= clickedSlotEndMinutes;
  }

  return clickedTimeMinutes <= zoneCurrentMinutes;
};
 
 
export const getSessionLanguageCode = () => {
    try {
         const stored = getLanguage();
          if (!stored) return "english";
 
        if (stored) {
            const parsed = JSON.parse(stored);
            const code = parsed.code;
 
            const languageMap = {
                fr: "french",
                cs: "czech",
                es: "spanish",
                it: "italian",
                de: "german",
                nl: "dutch",
                pl: "polish",
                pt: "portuguese",
                ga: "irish",
                en: "english"
            };
            //console.log("languageMap from appconstant-",languageMap[code]);
            return languageMap[code] || "english";
        }
 
        return "english";
    } catch {
        return "english";
    }
};

export function formatReactString(
  template,
  values = [],
  options = {}
) {
  const { renderers = {}, defaultRenderer } = options;

  const regex = /%(\d+\.\d+f|d|f|s)/g;

  let valueIndex = 0;
  let lastIndex = 0;
  const parts = [];

  template.replace(regex, (match, type, offset) => {
    // text before placeholder
    if (offset > lastIndex) {
      parts.push(template.slice(lastIndex, offset));
    }

    let rawValue = values[valueIndex];
    let value = rawValue;

    // ✅ safe fallback
    if (rawValue === undefined || rawValue === null) {
      value = "";
    } else {
      if (type === "d") {
        const parsed = parseInt(rawValue, 10);
        value = isNaN(parsed) ? "" : parsed;
      } else if (type === "f") {
        const parsed = parseFloat(rawValue);
        value = isNaN(parsed) ? "" : parsed;
      } else if (type.includes(".") && type.endsWith("f")) {
        const decimals = parseInt(type.split(".")[1], 10);
        const parsed = parseFloat(rawValue);
        value = isNaN(parsed) ? "" : parsed.toFixed(decimals);
      }
    }

    // ✅ renderer priority:
    // 1. index renderer
    // 2. type renderer (%s, %d, etc.)
    // 3. default renderer
    const renderer =
      renderers[valueIndex] ||
      renderers[type] ||
      defaultRenderer;

    parts.push(
      renderer ? renderer(value, type, valueIndex) : value
    );

    valueIndex++;
    lastIndex = offset + match.length;
  });

  // remaining text
  if (lastIndex < template.length) {
    parts.push(template.slice(lastIndex));
  }

  return parts.map((part, index) => {
    if (React.isValidElement(part)) {
      return React.cloneElement(part, {
        key: part.key ?? `formatted-part-${index}`,
      });
    }

    return part;
  });
}

/* ----------------------------- */
/* How to Use formatReactString: */
/* ----------------------------- */

/* Case 1 — No styling [Do NOT pass anything unless you need styling]
formatReactString(template, [spotName]);

Case 2 — Style everything
formatReactString(template, [spotName], {
  defaultRenderer: (val) => (
    <span className="color-dark-black">{val}</span>
  )
});
Case 3 — Style selectively
formatReactString(template, [spotName], {
  renderers: {
    s: (val) => <strong>{val}</strong>
  }
}); 
🔤 %s → String

Used for text values

Example:
const template = "Room: %s";

formatReactString(template, ["Meeting Room A"]);

✔ Output:

Room: Meeting Room A
🔢 %d → Integer

Used for whole numbers (no decimals)

Example:
const template = "You have %d bookings";

formatReactString(template, [5]);

✔ Output:

You have 5 bookings

👉 If you pass "5.8" → it becomes 5
👉 If invalid ("abc") → becomes "" (safe fallback)

🔣 %f → Float

Used for decimal numbers

Example:
const template = "Price: €%f";

formatReactString(template, [12.5]);

✔ Output:

Price: €12.5
🎯 %0.2f → Float with 2 decimal places

Used for formatted decimals

Example:
const template = "Price: €%0.2f";

formatReactString(template, [12.5]);

✔ Output:

Price: €12.50

👉 Always shows 2 decimal places

✅ Combined example
const template = "%s has %d bookings worth €%0.2f";

formatReactString(template, ["John", 3, 45.678]);

✔ Output:

John has 3 bookings worth €45.68
🎨 With styling (your use case)
formatReactString(
  "%s has %d bookings",
  ["John", 5],
  {
    renderers: {
      s: (val) => <span className="color-dark-black">{val}</span>
    }
  }
);

✔ Output:

“John” styled
“5” normal
🧠 Key takeaway
Placeholder	Meaning	Example Input	Output
%s	string	"Room A"	Room A
%d	integer	5.8	5
%f	float	12.5	12.5
%0.2f	float (2 decimals)	12.5	12.50
*/
// Start  -Do disable NEXT button in case of no slots available for booking
export const getDisabledSlotsAndButtonState = ({
  timeIntervals = [],
  blockedBookingTimeSlots = [],
  bookedSlots = [],
  startDate,
  currentDate,
  currentTime,
  isTimeBefore,
}) => {
  // Store disabled slots
  const disableSlots = [
    ...bookedSlots,
    ...blockedBookingTimeSlots,
  ];

  // Disable past time slots if selected date is today
  if (startDate === currentDate) {
    timeIntervals.forEach((timeSlot) => {
      const [, endTime] = timeSlot.split(" - ");

      if (!isTimeBefore(currentTime, endTime)) {
        disableSlots.push(timeSlot);
      }
    });
  }

  // Remove duplicates
  const uniqueDisableSlots = [...new Set(disableSlots)];

  // Check if all slots are disabled
  const isNextButtonDisabled =
    JSON.stringify(timeIntervals) ===
      JSON.stringify(blockedBookingTimeSlots) ||
    timeIntervals.length === uniqueDisableSlots.length;

  return {
    disableSlots: uniqueDisableSlots,
    isNextButtonDisabled,
  };
};
export const isTimeBefore = (currentTime, endTime) => {
  const current = new Date(`1970-01-01T${currentTime}:00`);
  const end = new Date(`1970-01-01T${endTime}:00`);

  return current < end;
};
// End    -Do disable NEXT button in case of no slots available for booking